import {Injectable} from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class NavigationService {

    constructor() {
    }

    getNextStep(connectToken : string) : string {
        if(connectToken && connectToken.startsWith("D")){
            return  'shared-docs';
        } else if(connectToken && connectToken.startsWith("C")){
            return  'cirfs';
        } else if(connectToken && (connectToken.startsWith("L") || connectToken.startsWith("T"))){
            return  'matter-summary';
        } else{
            return undefined;
        }
    }
}
